import { useEffect, useRef } from "react";
import { useNavigate } from 'react-location';

import "./Card.scss";

export const Card = ({ cardInfo, handleNext, handlePrevious, isFocus, isNext, isTransitionEnabled }) => {
  const navigate = useNavigate({ from: '/' });
  const cardRef = useRef(null);

  const handleCardClick = () => {
    if (isFocus) {
      navigate({ to: cardInfo.url });
    }
    else {
      isNext ? handleNext?.() : handlePrevious?.();
    }
  }

  useEffect(() => {
    if (cardRef.current) {
      cardRef.current.style.transition = isTransitionEnabled ? 'transform 1s ease' : 'none';
      cardRef.current.className = `carousel--card ${isFocus ? 'carousel--card__active' : ''}`
    }
  }, [isTransitionEnabled, isFocus]);

  return (
    <div
      className="carousel--card"
      onClick={handleCardClick}
      ref={cardRef}
    >
      <div className={`carousel--card__image--wrapper carousel--card__${cardInfo.classSuffix}`}>
        <img className="carousel--card__image" src={cardInfo.image} alt={cardInfo.alt} />
        <div className={`${isFocus ? '' : 'carousel--card__inactive'}`} />
      </div>
    </div>
  )
};

export default Card;
